import type { ApprovalData } from '@/api/availability'
import { useQuery } from '@tanstack/react-query'
import { client } from '../lib/api-client'

const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000

export function useApprovals() {
  return useQuery<ApprovalData>({
    queryKey: ['approvals'],
    queryFn: async () => {
      const response = await client.api.v1.approvals.$get()
      if (!response.ok) throw new Error('Failed to fetch approvals')
      return response.json() as Promise<ApprovalData>
    },
    staleTime: TWENTY_FOUR_HOURS,
    gcTime: TWENTY_FOUR_HOURS,
    refetchOnWindowFocus: false,
  })
}
